import $ from 'jquery';
// import { breakpoints } from './_site';

export const toggleSwitcher = ($el) => {
    var $switcher = $($el.attr('href')),
        switcherActiveClass = 'switcher--active';

    $switcher.toggleClass(switcherActiveClass);
};

export const binds = () => {
    $('[data-toggle-switcher]').on('click.switcher', function(event) {
        toggleSwitcher($(this));
        event.preventDefault();
    });
};
